import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { cfRegionLinks } from 'src/app/helper/cfRegionLinks';
import { CustomerdatabaseService } from 'src/app/services/customerdatabase.service';
import { GoogleService } from 'src/app/services/google.service';

@Component({
  selector: 'app-google-login',
  templateUrl: './google-login.component.html',
  styleUrls: ['./google-login.component.scss'],
})
export class GoogleLoginComponent implements OnInit {
  @Input() currentPage: string = ''; // Define an input to receive the page name

  constructor(
    private googleService: GoogleService,
    private http: HttpClient,
    private AlertCtrl: AlertController,
    private customerDB: CustomerdatabaseService
  ) { }

  ngOnInit() { }

  async googleLogin() {
    try {
      const userCredential = await this.googleService.googleLogin();
      console.log("userCredential", userCredential);
      let accessToken = userCredential.credential.accessToken;
      let refreshToken = userCredential.credential.idToken;
      let googleProfile = userCredential.additionalUserInfo.profile;
      console.log("accessToken", accessToken);
      console.log("refreshToken", refreshToken);
      if (this.currentPage === 'integrations') {
        this.testCalendarAccess(accessToken, refreshToken, googleProfile);
      } else if (this.currentPage === 'login') {
        this.saveCredentials(accessToken, refreshToken, googleProfile);
      } else if (this.currentPage === "contorlpanel") {

      } else if (this.currentPage === "profile") {
        this.testCalendarAccess(accessToken, refreshToken, googleProfile);
      }
    } catch (error) {
      console.error('Google login failed:', error);
    }
  }

  testCalendarAccess(accessToken, refreshToken, googleProfile) {
    console.log("accessToken", accessToken);
    console.log("refreshToken", refreshToken);
    const body = {
      accessToken: accessToken,
      refreshToken: refreshToken,
      endpoint: "Test"
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = cfRegionLinks.calendarHandler;
    this.http.post(url, body, { headers }).subscribe((res) => {
      console.log('Calendar access test:', res);
    }, (res2) => {
      if (res2.status === 401) {
        console.log('Calendar access test:', res2);
        this.presentAlert('Please login again', 'Access denied');
      } else if (res2.status === 200) {
        console.log('Calendar access test:', res2);
        this.presentAlert('Access granted', 'Success');
        this.saveCredentials(accessToken, refreshToken, googleProfile);
      }
    });
  }

  async presentAlert(message, header) {
    const alert = await this.AlertCtrl.create({
      header: header,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }

  async saveCredentials(accessToken, refreshToken, googleAccessRights) {
    this.customerDB.saveGoogleCredentials(accessToken, refreshToken, googleAccessRights);
  }
}
